import { render, staticRenderFns } from "./UpdateICDX.vue?vue&type=template&id=1bacb93e"
import script from "./UpdateICDX.vue?vue&type=script&lang=js"
export * from "./UpdateICDX.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bacb93e')) {
      api.createRecord('1bacb93e', component.options)
    } else {
      api.reload('1bacb93e', component.options)
    }
    module.hot.accept("./UpdateICDX.vue?vue&type=template&id=1bacb93e", function () {
      api.rerender('1bacb93e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/home/icdx/UpdateICDX.vue"
export default component.exports